import { authHttp } from '../http'
import * as routes from '../../routes/picking.routes'
import { errorHandler } from '../../../util/error.service'

export async function saveArea({ id, name, nickName, tp_id, actived, sequence }) {
  try {
    let response
    if (id) {
      response = await authHttp().put(routes.urlPostPutAreaSeparacao, {
        id,
        name,
        nickName,
        tp_id,
        actived,
        sequence,
      })
    } else {
      response = await authHttp().post(routes.urlPostPutAreaSeparacao, {
        name,
        nickName,
        tp_id,
        actived,
        sequence,
      })
    }
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function saveMultiplesArea(qte, name, comecaEm, tpId) {
  try {
    const response = await authHttp().post(routes.urlPostMultipleAreaSeparacao, {
      qte,
      tp_id: tpId,
      baseName: name,
      comecaEm,
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getAreas(tp_id) {
  try {
    const response = await authHttp().get(routes.urlGetAreasSeparacao(tp_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function assocAreaClient(area_id, client_id) {
  try {
    await authHttp().put(routes.urlAssociacaoAreaCliente(), { area_id, client_id })
  } catch (error) {
    throw errorHandler(error)
  }
}
